import { Box } from '@mantine/core';
import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/author/_author/presentation/_presentation')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sidebar.presentations' },
  },
});

function RouteComponent() {
  return (
    <Box p="md">
      <Outlet />
    </Box>
  );
}
